import React, { useState, useCallback, useEffect } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import AdminNavigation from "./AdminNavigation";
import Textarea from "../../forms/Textarea";
import InputGroup from "../../forms/InputGroup";
import { api } from "../index.api";
import { validateField } from "../../pages/functions";
import AdminConfirmationModal from "./adminConfirmationModal";
import {
  TranslationsDraftToliveFields,
  TranslationsRevertliveFields,
} from "./ManageTranslationField";
import "./styles.css";
import { REF_DATA } from "../../constants";
import { getApplicationRegex } from "../plugins/utils";

const ManageTranslationsLive = (props) => {
  const [activeTraslationLiveTab, setActiveTraslationLiveTab] =
    useState("draftToLive");
  const [fields, setFields] = useState(TranslationsDraftToliveFields);
  const [revertFields, setRevertFields] = useState(
    TranslationsRevertliveFields
  );
  const [createDraftState, setCreateDraftState] = useState(false);
  const [revertLiveState, setRevertLiveState] = useState("");
  const [showAdminConfirmationModal, setShowAdminConfirmationModal] =
    useState(false);
  const [modalBodyContent, setModalBodyContent] = useState("");

  const getLiveAndDraftDetails = useCallback(() => {
    api.admin.translation.fetchLiveAndDraftDetails((response) => {
      const draftVersionDetails = response.filter(
        (res) => res.type.toLowerCase() === "draft"
      );
      if (draftVersionDetails.length > 0) {
        setCreateDraftState(true);
        setFields((prevState) => ({
          ...prevState,
          draftVersionComment: {
            ...prevState.draftVersionComment,
            value: draftVersionDetails[0].versionComments,
          },
        }));
      }
    });
  }, [fields]);

  useEffect(() => {
    getLiveAndDraftDetails();
  }, []);

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const validate = useCallback((e, field) => {
    const inputValue = e.target.value.toLowerCase();
    const ref_Data = props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);

    if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
      // Emoji detected, prevent it from being added
      showNotification(
        "Error!",
        "Special characters are not allowed",
        "error"
      );
      return;
    } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
      // HTML Tags and Script detected, prevent it from being added
      showNotification(
        "Error!",
        "Submission fails. Input contains prohibited words. Please remove them and try again.",
        "error"
      );
      return;
    } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
      showNotification(
        "Error!",
        "Validation configuration is missing. Please contact support.",
        "error"
      );
      return;
    }
    
    const validateFields = validateField(e, field, fields);
    setFields({ ...validateFields });
  }, []);

  const makeDraftLiveHandler = (res) => {
    if (res.status === 200) {
      setCreateDraftState(false);
      showNotification(
        "Success",
        "Draft is make it live successfully",
        "success"
      );
    } else {
      showNotification("Error", "Please try again later", "error");
    }
  };

  const handleMakeDraftLive = () => {
    setShowAdminConfirmationModal(false);
    api.admin.translation.makeDraftLive(makeDraftLiveHandler);
  };

  const revertLiveHandler = (res) => {
    if (res.status === 200) {
      setRevertLiveState(
        `Successfully Reverted. Please close MI Portal App  and login again to see the changes.`
      );
      showNotification("Success", "Revert the changes successfully", "success");
    } else {
      showNotification("Error", "Please try again later", "error");
    }
  };

  const handleRevertLive = () => {
    setShowAdminConfirmationModal(false);
    api.admin.translation.revertToPreviousLive(revertLiveHandler);
  };

  const handleActiveTranslationLiveTab = () => {
    setActiveTraslationLiveTab("changeLive");
    api.admin.translation.getActiveAndPreviousLiveVersions((res) => {
      if (
        res.activeLiveVersion.toString() &&
        res.previousLiveVersion.toString()
      ) {
        setRevertFields((prevState) => ({
          ...prevState,
          currentLiveVersion: {
            ...prevState.currentLiveVersion,
            value: res.activeLiveVersion.toString(),
          },
          revertVersionTo: {
            ...prevState.revertVersionTo,
            value: res.previousLiveVersion.toString(),
          },
        }));
      } else {
        showNotification("Error", "Please try again later", "error");
      }
    });
  };

  const takeAction = useCallback(() => {
    if (activeTraslationLiveTab === "draftToLive") {
      handleMakeDraftLive();
    } else if (activeTraslationLiveTab === "changeLive") {
      handleRevertLive();
    }
  }, [activeTraslationLiveTab]);

  return (
    <div id="manage-admin-list" className="v2_container">
      <div className="row">
        <AdminConfirmationModal
          isModalOpen={showAdminConfirmationModal}
          toggleYes={takeAction}
          toggleCancel={() => setShowAdminConfirmationModal(false)}
          bodyContent={modalBodyContent}
        />
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row manage-admin-list-header">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Manage Translations Live</h3>
            </div>
          </div>
          <div className="translationLive_wrapper">
            <div className="row translationsLiveTabHeader">
              <div
                className={`col-4 col-xl-4 col-sm-6 translationsLiveTab ${
                  activeTraslationLiveTab === "draftToLive" ? "activeTab" : ""
                }`}
                onClick={() => setActiveTraslationLiveTab("draftToLive")}
              >
                Move Draft to Live
              </div>
              <div
                className={`col-4 col-xl-4 col-sm-6 translationsLiveTab ${
                  activeTraslationLiveTab === "changeLive" ? "activeTab" : ""
                }`}
                onClick={handleActiveTranslationLiveTab}
              >
                Change Live Version
              </div>
            </div>
            {activeTraslationLiveTab === "draftToLive" && !createDraftState && (
              <h4 className="noDraftFound">
                There is no draft version in progress, go to Manage Translation
                Draft to create it
              </h4>
            )}
            {activeTraslationLiveTab === "changeLive" && createDraftState && (
              <h4 className="activeDraftFound">
                Active Draft version is there. Please delete Draft and come back
                here.
              </h4>
            )}
            {activeTraslationLiveTab === "draftToLive" && createDraftState && (
              <div>
                <div className="row draftVersionComment_section">
                  <div className="col-lg-12">
                    <Textarea
                      rows={4}
                      maxLength={4000}
                      isDisabled={true}
                      style={{ borderRadius: "4px" }}
                      field={fields.draftVersionComment}
                      validate={(e) => validate(e, fields.draftVersionComment)}
                    />
                  </div>
                </div>
                <div>
                  <button
                    className="btn btn-lg btn-info btn-rounded"
                    onClick={() => {
                      setShowAdminConfirmationModal(true);
                      setModalBodyContent(
                        "Are you sure you want to make this version the live version?"
                      );
                    }}
                  >
                    Make Draft Live
                  </button>
                </div>
              </div>
            )}

            {activeTraslationLiveTab === "changeLive" && !revertLiveState && (
              <div className="translationsRevertBody">
                {Number(revertFields.revertVersionTo.value) <= 0 &&
                  !createDraftState && (
                    <h4 className="activeDraftFound">
                      Previous Versions not available.
                    </h4>
                  )}
                <div className="col-12 col-md-12 col-sm-12 col-xl-4">
                  <InputGroup
                    type="number"
                    searchable={false}
                    clearable={false}
                    disabled={true}
                    field={revertFields.currentLiveVersion}
                    validate={(e) => validate(e, fields.currentLiveVersion)}
                  />
                </div>
                <div className="col-12 col-md-12 col-sm-12 col-xl-4">
                  <InputGroup
                    type="number"
                    searchable={false}
                    clearable={false}
                    field={revertFields.revertVersionTo}
                    disabled={true}
                    validate={(e) => validate(e, fields.revertVersionTo)}
                  />
                </div>
                <button
                  className="btn btn-lg btn-info btn-rounded"
                  onClick={() => {
                    setShowAdminConfirmationModal(true);
                    setModalBodyContent(
                      "Are you sure you want to revert this version?"
                    );
                  }}
                  disabled={
                    createDraftState ||
                    Number(revertFields.revertVersionTo.value) <= 0
                  }
                >
                  Confirm Reverting
                </button>
              </div>
            )}

            {activeTraslationLiveTab === "changeLive" && revertLiveState && (
              <h4 className="DraftRevertSuccess">{revertLiveState}</h4>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    referenceData: state.referenceData
  };
}

export default connect(mapStateToProps, { notify })(ManageTranslationsLive);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ManageTranslationsLive.js